import React, { createContext, useContext, useEffect, useState } from "react";
import enTranslations from "../translations/en.json";
import seTranslations from "../translations/se.json";
import { useCustomerPanelSettings } from "./CustomerPanelSettingsContext";

const LocalizationContext = createContext();

const translationFiles = {
  en: enTranslations,
  se: seTranslations,
};

export const LocalizationProvider = ({ children }) => {
  const { language } = useCustomerPanelSettings();
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = () => {
      if (language) {
        const selectedTranslations =
          translationFiles[language] || translationFiles.en;
        setTranslations(selectedTranslations);
      }
    };

    loadTranslations();
  }, [language]);

  const t = (key, params = {}) => {
    const keys = key.split(".");
    let translation = translations;
    for (const k of keys) {
      if (translation && typeof translation === "object" && k in translation) {
        translation = translation[k];
      } else {
        return key; // Return the key if not found
      }
    }

    if (typeof translation === "string") {
      Object.keys(params).forEach((paramKey) => {
        const regex = new RegExp(`{${paramKey}}`, "g");
        translation = translation.replace(regex, params[paramKey]);
      });
    }

    return typeof translation === "string" ? translation : key;
  };

  return (
    <LocalizationContext.Provider value={{ t }}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);
